module.exports = __webpack_public_path__ + "img/transport_category_2.4fc477a2.svg";